import { useCallback, useState } from 'react';
import { apiClient, buildAuthRequestConfig } from '../utils/apiClient';

const usePost = (withHeaderJson=true) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postData = useCallback(async (url, payload, requestConfig = {}) => {
        setLoading(true);
        setError(null);
        const headers = withHeaderJson ? { 'Content-Type': 'application/json; charset=utf-8' } : {};
        const config = buildAuthRequestConfig(requestConfig, headers);
        try {
            const response = await apiClient.post(url, payload, config);
            setData(response.data);
            setLoading(false);
            return response.data;
        } catch (error) {
            setError(error);
            setLoading(false);
            throw error;
        }
    }, [withHeaderJson]);

    return { data, loading, error, postData };
};

export default usePost;
